module.exports = __webpack_public_path__ + "img/SUTD-Productions-Logo-white.4527d02e.png";